<template>

    <div class="auth">
        <div class="auth-card">
            <div class="auth-head">
                <div class="auth-badge">OA</div>
                <h1 class="auth-title">{{ is_register ? 'Создать аккаунт' : 'Вход' }}</h1>
                <p class="auth-sub">{{ is_register ? 'Заполните поля для регистрации' : 'Введите логин и пароль' }}</p>
            </div>
            <div class="auth-form">
                <InputUI :min_width="100" @myData="login = $event" :title="'Логин'" :icon="'user'" :placeholder="'Логин пользователя'"/>
                <InputUI :min_width="100" @myData="password = $event" :title="'Пароль'" :icon="'lock'" :placeholder="'Пароль пользователя'" :input_type="'password'"/>
                <InputUI v-if="is_register" :min_width="100" @myData="password2 = $event" :title="'Повторите пароль'" :icon="'lock'" :placeholder="'Повторите пароль'" :input_type="'password'"/>
                <ButtonUI class="auth-submit" :title="is_register ? 'Зарегистрироваться' : 'Войти'" @click="submit()"/>
                <ButtonUI :title="is_register ? 'Уже есть аккаунт? Войти' : 'Нет аккаунта? Зарегистрироваться'" variant="ghost" @click="switchMode()"/>
                <ButtonUI :title="'На главную'" variant="ghost" size="sm" @click="$router.push('/')"/>
            </div>
        </div>
    </div>

</template>


<script>

import axios from 'axios'

import InputUI from '@/components/InputUI.vue';
import ButtonUI from '@/components/ButtonUI.vue';

import { checkAuth, saveSession } from '@/auth/auth'

export default {
    name: 'AuthView',

    created() {
        // уже авторизован - на страницу входа нет смысла
        if (checkAuth()) {
            this.$router.push('/');
        }
    },

    components:{
        InputUI,
        ButtonUI
    },

    data() {
        return {
            login: "",
            password: "",
            password2: "",
            is_register: false
        }
    },

    methods: {
        switchMode(){
            this.is_register = !this.is_register;
        },

        submit(){
            const login = this.login.trim();

            if (login.length < 3){
                return alert("Логин должен содержать минимум 3 символа");
            }

            if (this.password.length < 4){
                return alert("Пароль должен содержать минимум 4 символа");
            }

            if (this.is_register && this.password !== this.password2){
                return alert("Пароли не совпадают");
            }

            const url = this.is_register
                ? "/api/v1/auth/register"
                : "/api/v1/auth";

            axios.post(url, {
                login: login,
                password: this.password
            }, {
                headers:{
                    accept: 'application/json',
                    'Content-Type': 'application/json'
                },
            }).then((response) => {
                if(response.status == 200){
                    saveSession(response.data);
                    alert(this.is_register ? "Аккаунт создан" : "Вы успешно авторизовались");
                    this.$router.push('/');
                }
            }).catch((error) => {
                const status = error.response ? error.response.status : null;

                if (status == 409){
                    alert("Пользователь с таким логином уже существует");
                } else if (status == 401){
                    alert("Введён не верный логин или пароль");
                } else if (status == 422){
                    alert("Логин от 3 символов, пароль от 4 символов");
                } else {
                    alert("Сервер недоступен. Запустите backend и попробуйте снова");
                }
            })
        }
    }
}

</script>


<style scoped>

.auth{
    min-height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 24px;
}

.auth-card{
    width: 100%;
    max-width: 380px;

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 14px;
    box-shadow: var(--shadow-sm);

    padding: 28px;
}

.auth-head{
    text-align: center;

    margin-bottom: 20px;
}

.auth-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;

    margin-bottom: 12px;

    background: var(--primary);
    color: var(--primary-foreground);
    border-radius: 10px;

    font-size: 14px;
    font-weight: 700;
}

.auth-title{
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.auth-sub{
    margin-top: 4px;

    font-size: 13px;
    color: var(--muted-foreground);
}

.auth-form{
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.auth-form > *{
    width: 100%;
}

</style>
